const logger = console;
const isOrbitBrowserUrl = '/v1/authentication/browser';

/**
 * Check is user is on orbit browser
 */
export const requestIsOrbitBrowser = async (): Promise<boolean> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return await fetch(isOrbitBrowserUrl, {
    cache: 'no-cache',
    credentials: 'include',
    method: 'GET'
  })
    .then(res => {
      try {
        if (res.status >= 400) {
          throw new Error(`Is orbit browser api call failed with response status ${res.status}`);
        }
        return res.json();
      } catch (err) {
        logger.error(`Error determining if user is on orbit browser`, err);
        return false;
      }
    })
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    .then(res => res?.isOrbit)
    .catch(err => {
      logger.error(`Error determining if user is on orbit browser.`, err);
      return false;
    });
};
